import { HttpParams } from '@angular/common/http';
import _ from 'lodash';

type HttpParameterValue = string | string[] | number | boolean;
type HttpParameter<T> = { [P in keyof T]: HttpParameterValue };

export function getHttpParameters<T>(params: T, keepEmpty = false): HttpParams {
  const httpGetParameter: HttpParameter<T> = convertToHttpParameter(params, keepEmpty);
  return new HttpParams({ fromObject: httpGetParameter });
}

function removeEmpty<T>(param: unknown[] | T): unknown[] | T {
  if (Array.isArray(param)) {
    return param.filter((entry) => !_.isNil(entry));
  }
  return param;
}

function convertToHttpParameter<T>(object: T, keepEmpty = false): HttpParameter<T> {
  if (!object) {
    return {} as HttpParameter<T>;
  }
  const objWithStringIndex = <{ [key: string]: HttpParameterValue }>object;

  Object.keys(object).forEach((key) => {
    objWithStringIndex[key] = <HttpParameterValue>removeEmpty(objWithStringIndex[key]);
  });

  const cleanParams = _.pickBy(object as Record<string, unknown>, (param) => paramIsDefined(param, keepEmpty)) as T;
  return cleanParams as unknown as HttpParameter<T>;
}

function paramIsDefined(param: unknown, keepEmpty = false): boolean {
  if (Array.isArray(param)) {
    return param.length > 0;
  }
  return keepEmpty ? !_.isNil(param) : !_.isNil(param) && param !== '';
}
